import { useEffect, useState } from "react";
import { ISetOutfit } from "../../../models/interactions/SetOutfit";
import Interaction from "../../../models/interactions/Interaction";
import NodeActorDropdown from "../components/NodeActorDropdown";
import NodeStringDropdown from "../components/NodeStringDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

interface Outfit {
  outfit_name: string;
  outfit_preview_male: string;
}

export default function SetOutfitNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const setOutfit = props.interaction as ISetOutfit;
  const { updateInteraction } = useUpdateSequenceInteraction();
  const [outfits, setOutfits] = useState<Outfit[]>([]);

  useEffect(() => {
    // Load outfits from JSON file
    fetch("/outfits/Outfits.json")
      .then((response) => response.json())
      .then((data) => setOutfits(data))
      .catch((error) => console.error("Error loading outfits:", error));
  }, []);

  const outfitNames = outfits.map((outfit) => outfit.outfit_name);

  const actorDropdown = (
    <NodeActorDropdown
      label="Actor"
      selectedActorId={setOutfit.actorId}
      onClick={(actorId: string) =>
        updateInteraction(props.nodeId, {
          ...setOutfit,
          actorId: actorId,
        } as ISetOutfit)
      }
    />
  );

  const outfitDropdown = (
    <NodeStringDropdown
      label="Outfit"
      items={outfitNames}
      selectedItem={setOutfit.outfitName || "Select an outfit"}
      onClick={(outfitName) =>
        updateInteraction(props.nodeId, {
          ...setOutfit,
          outfitName: outfitName,
        } as ISetOutfit)
      }
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {actorDropdown}
      {outfitDropdown}
    </div>
  );
}
